import { defineComponent } from 'vue';
import { routerLink } from '~/plugins/router-link';
function queryLink(text, content) {
    return "tags=" + text + "," + (content || 'stagecontents');
}
var listData1 = [
    {
        imageUrl: '/images/top/schedule/img1.png',
        link: {
            url: routerLink.areaguide(queryLink('1121-1123'))
        },
        title: 'OPENING WEEK',
        content: ['イルミネーションとジャズで彩る開幕週']
    },
    {
        imageUrl: '/images/top/schedule/img2.png',
        link: {
            url: routerLink.areaguide(queryLink('1124-1130'))
        },
        title: 'ART & PERFORMANCE WEEK',
        content: ['芸術・アート・ダンスで心躍る！']
    },
    {
        title: 'PET & SMILE WEEK',
        content: ['ペットと楽しむクリスマス！'],
        imageUrl: '/images/top/schedule/img3.png',
        link: {
            url: routerLink.areaguide(queryLink('1201-1207'))
        }
    },
    {
        title: 'IDOL PERFORMANCE WEEK',
        content: ['華やかなアイドルたちがクリスマスを彩る'],
        imageUrl: '/images/top/schedule/img4.png',
        link: {
            url: routerLink.areaguide(queryLink('1208-1214'))
        }
    },
    {
        title: 'KIDS WEEK',
        content: ['主役は子どもたち！参加＆体験型ステージを楽しもう'],
        imageUrl: '/images/top/schedule/img5.png',
        link: {
            url: routerLink.areaguide(queryLink('1215-1221'))
        }
    },
    {
        title: 'Xmas WEEK',
        content: ['クリスマス直前！華やかなステージを楽しもう'],
        imageUrl: '/images/top/schedule/img6.png',
        link: {
            url: routerLink.areaguide(queryLink('1222-1225'))
        }
    }
];
var listData2 = [
    {
        title: 'OPENING WEEK',
        content: ['手作りワークショップと探検ラリー'],
        imageUrl: '/images/top/schedule/image1.png',
        link: {
            url: routerLink.areaguide(queryLink('1121-1123', 'areacontents'))
        }
    },
    {
        title: 'ART WEEK',
        content: ['作って遊ぼう！レゴ®クリスマスツリー登場'],
        imageUrl: '/images/top/schedule/image2.png',
        link: {
            url: routerLink.areaguide(queryLink('1124-1130', 'areacontents'))
        }
    },
    {
        title: 'GAME & TOY WEEK',
        content: ['あの黒ひげ危機一発に挑戦！'],
        imageUrl: '/images/top/schedule/image3.png',
        link: {
            url: routerLink.areaguide(queryLink('1201-1207', 'areacontents'))
        }
    },
    {
        title: 'ACTIVE WEEK',
        content: ['走って遊んで、クリスマス！'],
        imageUrl: '/images/top/schedule/image4.png',
        link: {
            url: routerLink.areaguide(queryLink('1208-1214', 'areacontents'))
        }
    },
    {
        title: 'CRAFT WEEK',
        content: ['クリスマス準備を楽しもう'],
        imageUrl: '/images/top/schedule/image5.png',
        link: {
            url: routerLink.areaguide(queryLink('1215-1221', 'areacontents'))
        }
    },
    {
        title: 'Xmas WEEK',
        content: ['最後まで楽しむ4日間'],
        imageUrl: '/images/top/schedule/image6.png',
        link: {
            url: routerLink.areaguide(queryLink('1222-1225', 'areacontents'))
        }
    }
];
export default defineComponent({
    data: function () {
        return {
            listData1: listData1,
            listData2: listData2
        };
    }
});
